import TermsAndConditions from '@wetransfer/transfer/modules/terms-and-conditions';

export const init = () => {
  TermsAndConditions.configure();
};
